<template>
  <component class="w-full" :editState="editState" :is="activeStateMod" :states="states" :statesWithKey="statesWithKey"></component>
</template>

<script>
  import {eventBus} from "../../eventbus";
  import StatesIndex from "./StatesIndex";
  import StateAdd from "./StateAdd";
  import StateEdit from "./StateEdit";
  import firebase from "firebase";
  import {db} from '@/db'


  export default {
    name: "ContentMain",
    firebase: {
      states: db.ref('states').orderByChild('cases'),
    },
    watch: {
      states() {
        this.getKeys()
      }
    },
    data() {
      return {
        activeStateMod: 'StatesIndex',
        editState: {},
        states: [],
        statesWithKey: [],


      }
    },
    methods: {
      listener() {
        eventBus.$on('AddState', () => this.activeStateMod = 'StateAdd')
        eventBus.$on('AllState', () => this.activeStateMod = 'StatesIndex')
        eventBus.$on('EditState', (x) => {
          this.activeStateMod = 'StateEdit';

          this.editState = {
            state: x.state,
            deaths: x.deaths,
            cases: 0 - x.cases,
            recovered: x.recovered
          }
        })
      },
      getKeys() {
        let keys = []
        firebase.database().ref('states/').once('value', function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            let key = {key: childSnapshot.key}
            let value = childSnapshot.val()
            keys.push({...key, ...value})

          })
        })
        this.statesWithKey = keys
      },
    },
    components: {
      StatesIndex,
      StateAdd,
      StateEdit
    },
    created() {
      this.listener()
      // this.getKeys()
    }

  }
</script>

<style scoped>
  .button {
    background: #9BC4D5;
  }
</style>